import { useEffect, useState } from 'react';
import Header from "./Header";
import Porcentaje from "./Porcentage";
import DataDocument from "./DataDocument";
import Footer from "./Footer";
import Card from "./Card";
import { getColorForKey } from "../functions/general";
import "../styles/ResultadoDocument.css";
import cardsData from "../assets/info/cards-ods.json";

import { useLocation, useNavigate, Link } from 'react-router-dom';

function ResultadoDocument() {
  const location = useLocation();
  const navigate = useNavigate();
  const { state } = location;

  const [selectedCard, setSelectedCard] = useState(null);

  const handleCloseCard = () => {
    setSelectedCard(null);
  };

  useEffect(() => {
    if (!state || !state.result || !state.metadata) {
      navigate('/error');
    }
  }, [state, navigate]);


  if (!state || !state.result || !state.metadata) {
    return (
      <div className="Document">
        <Header />
        <div id="error-mensaje">Error al procesar los datos</div>
        <Footer />
      </div>
    );
  }
  const info = state.metadata;
  const data = { ...state.result };

  // Reemplazamos la clave "0" por "17" si existe
  if (data.resultados["0"] !== undefined) {
    data.resultados["17"] = data.resultados["0"];
    delete data.resultados["0"];
  }

  const roundedResults = Object.entries(data.resultados).map(([key, value]) => [key, Math.floor(value * 100) / 100]);
  const filteredResults = roundedResults.filter(([key, value]) => value >= 0.3);
  const document = filteredResults.sort(([, a], [, b]) => b - a);

  const documentData = {
    nombre: info.name,
    peso: `${(info.size / 1024).toFixed(2)} KB`,
    idioma: info.language || "N/A",
    fecha: info.fecha ? new Date(info.fecha).toLocaleDateString() : "N/A",
    contenido: info.contenido
  };
  return (
    <div className="Document">
      <Header />
      <div className="data-container-document">

        <DataDocument {...documentData} />

        <div className="data-result">
          <div id="resultado-titulo">ODS Más Significativos</div>
          <div className="resultado-container">
            {document.map(([key, porcentaje], index) => (
              <Porcentaje
                key={index}
                imagen={`ods-${key}.jpg`}
                tono={getColorForKey(key)}
                porcentaje={porcentaje}
                isDocument={true}
                onClick={() => setSelectedCard(cardsData["ods-" + key])}
              />
            ))}
          </div>
        </div>
      </div>


      <div id='info'>
        <a class="animated-button" href="https://www.un.org/sustainabledevelopment/es/" target="_blank">
          <svg xmlns="http://www.w3.org/2000/svg" class="arr-2" viewBox="0 0 24 24">
            <path
              d="M16.1716 10.9999L10.8076 5.63589L12.2218 4.22168L20 11.9999L12.2218 19.778L10.8076 18.3638L16.1716 12.9999H4V10.9999H16.1716Z"
            ></path>
          </svg>
          <span class="text">Más información sobre los ODS</span>
          <span class="circle"></span>
          <svg xmlns="http://www.w3.org/2000/svg" class="arr-1" viewBox="0 0 24 24">
            <path
              d="M16.1716 10.9999L10.8076 5.63589L12.2218 4.22168L20 11.9999L12.2218 19.778L10.8076 18.3638L16.1716 12.9999H4V10.9999H16.1716Z"
            ></path>
          </svg>
        </a>
      </div>


      <div id='seguir'>
        <Link to="/" className="custom-link">Seguir analizando ➜
        </Link>
      </div>

      {selectedCard && (
        <div className="overlay" onClick={handleCloseCard}>
          <Card
            title={selectedCard.title}
            color={selectedCard.color}
            image={selectedCard.image}
            link={selectedCard.link}
            description={selectedCard.description}
          />
        </div>
      )}
      <iframe
        width="100%"
        height="1350px"
        src="https://forms.office.com/Pages/ResponsePage.aspx?id=r4yvt9iDREaFrjF8VFIjwdA0zPAR1IFBglALqaeuqZFUMloxV01EQUtLMzhBTE1WWVBIOEs0RDdKRy4u&embed=true"
        style={{ border: "none", maxWidth: "100%" }}
        allowFullScreen
        webkitallowfullscreen="true"
        mozallowfullscreen="true"
        msallowfullscreen="true">
      </iframe>

      <Footer />
    </div>
  );
}

export default ResultadoDocument;
